export const STATUS_VERIFY = {
  VERIFIED: "verified",
  FAIL: "fail",
  SUCCESS: "success",
  OVER_LIMITED: "over_limited",
  UNSOLD: "unsold",
  BLOCKED: "blocked",
  LOCKED: "locked",
  CANNOT_ACCESS: "cannot_access",
} as const;

export enum STAMP_STATUS {
  NEW = "new",
  BLANK = "new",
  PRODUCT_ASSIGNED = "product_assigned",
  PROCESSING = "processing",
  SOLD = "sold",
  WARRANTY_PROCESSING = "warranty_processing",
  WARRANTY_REPLACED = "warranty_replaced",
  ACTIVATED = "activated",
  BLOCKED = "blocked",
  LOCKED = "locked",
  SUCCESS = "success",
}

export const STAMP_CODE_UNSOLD: readonly string[] = [STAMP_STATUS.PRODUCT_ASSIGNED];

export const STAMP_CODE_VERIFIED: readonly string[] = [
  STAMP_STATUS.WARRANTY_REPLACED,
  STAMP_STATUS.ACTIVATED,
  STAMP_STATUS.WARRANTY_PROCESSING,
];

export const TEMPLATE_TYPES = {
  TEMPLATE_1: "mrw_template_1",
  TEMPLATE_4: "mrw_template_4", // Golden Pen — Warranty Barcode (route riêng /kichhoat)
} as const;

export const DEFAULT_TEMPLATE_ONE = {
  text_default: "#4B6166",
  color_warring: "#F38020",
  color_success: "#00994D",
  color_error: "#B61212",
} as const;

export const SOCIAL_NETWORK_LIST = {
  FACEBOOK: "facebook",
  INSTAGRAM: "instagram",
  YOUTUBE: "youtube",
  TWITTER: "twitter",
  TIKTOK: "tiktok",
  ZALO: "zalo",
  WEBSITE: "website",
  PHONE: "phone",
  EMAIL: "email",
  MESSAGE: "message",
  LINKEDIN: "linkedin",
  TIKI: "tiki",
  LAZADA: "lazada",
  SHOPEE: "shopee",
  SHOPIFY: "shopify",
} as const;

export const KEY_LOCAL_STORAGE = {
  THEME_SETTING: "THEME_SETTING",
  STAMP_MESSAGE_STATES: "qrx_stamp_messages",
  COMPANY_SCAN: "qrx_company_scan",
  BROWSER_ID: "browser_id",
  I18N_LANGUAGE: "i18nextLng",
} as const;

export enum VERIFICATION_TYPE {
  LANDING_PAGE = "landing_page",
}

/** Hotline hỗ trợ Golden Pen — dùng khi company chưa cấu hình SĐT riêng. */
export const DEFAULT_HOTLINE = "1900.9486";

// Validation rules
export const VALIDATION_RULES = {
  PHONE_PATTERN: /^[0-9]{10,11}$/,
  EMAIL_PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50,
} as const;
